import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentTaskComment, PaymentTaskFixedAsset } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1150. 支払タスク固定資産一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:payment_task_id/payment_task_fixed_assets
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};
const paymentTaskFixedAssets = (props: Props): Promise<PaymentTaskFixedAsset[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_fixed_assets`
  );
};

export const usePaymentTaskFixedAssets = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentTaskFixedAssets(props),
  });
};

export const usePaymentTaskFixedAssetsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'payment_tasks',
    props.task_id,
    'payment_task_fixed_assets',
  ];
};
